import axios from 'axios';

export type GetPensioenbijEventsArgs = {
  page?: number;
  pageSize?: number;
  status?: string[];
  searchQuery?: string;
  employerId?: string;
  mutationType?: string;
};

export type GetConnectionPensioenbijMutationsArgs = {
  connectionId: string;
  page?: number;
  pageSize?: number;
  status?: string[];
  searchQuery?: string;
  mutationType?: string;
};

export type GetEmployeePensioenbijMutationsArgs = {
  employeeId: string;
  employerId: string;
  page?: number;
  pageSize?: number;
  status?: string[];
  searchQuery?: string;
  mutationType?: string;
};

export type ResendPensioenbijEventsArgs = {
  connectionId: string | null;
  mutationIds: string[];
};

export type DeletePensioenbijEventsArgs = {
  connectionId: string;
  mutationIds: string[];
};

export const toolsServices = {
  async getPensioenbijEvents({
    page,
    pageSize,
    status,
    searchQuery,
    employerId,
    mutationType,
  }: GetPensioenbijEventsArgs) {
    return axios.get(`pensioenbij/mutations`, {
      params: { page, pageSize, status, searchQuery, employerId, mutationType },
    });
  },
  async getConnectionPensioenbijMutations({
    connectionId,
    page,
    pageSize,
    status,
    searchQuery,
    mutationType,
  }: GetConnectionPensioenbijMutationsArgs) {
    return axios.get(`connections/${connectionId}/pensioenbij/mutations`, {
      params: { page, pageSize, status, searchQuery, mutationType },
    });
  },
  async getEmployeePensioenbijMutations({
    employeeId,
    employerId,
    page,
    pageSize,
    status,
    searchQuery,
    mutationType,
  }: GetEmployeePensioenbijMutationsArgs) {
    return axios.get(`employers/${employerId}/employees/${employeeId}/pensioenbij/mutations`, {
      params: { page, pageSize, status, searchQuery, mutationType },
    });
  },
  async resendPensioenbijEvents({ connectionId, mutationIds }: ResendPensioenbijEventsArgs) {
    return axios.post(`connections/mutations`, { connectionId, mutationIds });
  },
  async deletePensioenbijEvents({ connectionId, mutationIds }: DeletePensioenbijEventsArgs) {
    return axios.post(`connections/mutations/delete`, { connectionId, mutationIds });
  },
};
